module.exports = __webpack_public_path__ + "img/img36.3f34ddca.svg";